var render = function render(){var _vm=this,_c=_vm._self._c;return _c('advanced-check-box-filter-modal',{attrs:{"checked":_vm.checked,"checkBoxValues":_vm.checkBoxValues,"title":_vm.$t('views.government.vote.votes')},on:{"close":function($event){return _vm.$emit('close')},"validate":v => _vm.$emit('validate', v)}})
}
var staticRenderFns = []

export { render, staticRenderFns }